module.exports = __webpack_public_path__ + "e1ae64dfb4d65627f9c5edc18784102b.svg";